import { Checkbox, ModalProps, message } from "antd";
import {
  MARK_PRODUCT_SOLD_OUT,
  MARK_PRODUCT_VARIANT_SOLD_OUT,
  PRODUCT_DETAIL_URL,
} from "../../../commons/constants/api-urls";
import useFetch from "../../../commons/hooks/useFetch";
import defaultAxios from "../../../commons/utils/axios";
import CustomModal from "../../../commons/components/CustomModal/CustomModal";
import styles from "./SoldOutFormPopup.module.scss";
import { useEffect, useState } from "react";
import ImageDisplay from "../../../commons/components/ImageDisplay";

interface ConfirmPopupProps extends ModalProps {
  className?: string;
  title: string;
  description: string;
  product: any;
}

export default function SoldOutFromPopup({ className, title, description, product, ...modalProps }: ConfirmPopupProps) {
  const { data, refresh } = useFetch<any>(product && PRODUCT_DETAIL_URL(product.id));
  const [checkAll, setCheckAll] = useState(false);

  useEffect(() => {
    product && setCheckAll(product.is_sold_out);
  }, [product, product?.is_sold_out, refresh]);

  const handleSelectAll = async (event: any) => {
    const isChecked = event.target.checked;
    try {
      await defaultAxios.put(MARK_PRODUCT_SOLD_OUT(product.id), { is_sold_out: isChecked });
      setCheckAll(isChecked);
      message.success(`Successfully`);
      refresh();
    } catch (error) {
      event.target.checked = !isChecked;
      message.error(`Mark product sold out failed`);
    }
  };

  const handleSelect = async (event: any) => {
    const isChecked = event.target.checked;
    const value = event.target.value;
    try {
      await defaultAxios.put(MARK_PRODUCT_VARIANT_SOLD_OUT(product.id, value, isChecked));
      message.success(`Successfully`);
      refresh();
    } catch (error) {
      event.target.checked = !isChecked;
      message.error(`Mark item sold out failed`);
    }
  };

  return (
    <CustomModal className={styles.soldOutPopup} {...modalProps}>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
      {product && (
        <div className={styles.productForm}>
          <div className={styles.formHeader}>
            <Checkbox defaultChecked={product.is_sold_out} value={product.id} onChange={handleSelectAll} />
            <div className={styles.imageWrapper}>
              <ImageDisplay src={product.images[0] || ""} alt="" />
            </div>
            <div>{product.name}</div>
          </div>
          <div className={styles.formBody}>
            {!checkAll &&
              data &&
              data.items &&
              data.attributes.map(
                (att: any, index: number) =>
                  att.attribute_name !== "default" && (
                    <div className={styles.attributeWrapper} key={index}>
                      <h3>{att.attribute_name}</h3>
                      <div style={{ width: "100%", display: "block" }}>
                        {att.variants.map((variant: any, idx: number) => (
                          <div className={styles.checkBoxGroupWrapper}>
                            <Checkbox
                              defaultChecked={variant.isSoldOut}
                              value={variant.id}
                              onChange={handleSelect}
                              className={styles.checkBox}
                            >
                              {variant.attribute_value}
                            </Checkbox>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
              )}
          </div>
        </div>
      )}
    </CustomModal>
  );
}
